module.exports = __webpack_public_path__ + "assets/color-bounce-black.0ac20eaf94e876c2fb5626f3f104a422.gif";